var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-cities"},[_c('div',{staticClass:"home-cities__map"},[(_vm.shopsList)?_c('shops-map',{attrs:{"is-show-shop-types":true,"shops-list":_vm.shopsList}}):_c('div',{staticClass:"loader-mini__container"},[_c('div',{staticClass:"loader-mini"})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }